import _ from 'lodash';
import createjs from 'createjs-collection';

import * as fJS from './../cjsRoot/fJS';
import { cjsSelect } from './cjsSelect';
import { cjsEffects } from './../cjsObjects/cjsEffects';

var doll = false;

export class cjsHangman extends cjsSelect {
  _removeClicked;

  constructor(obj) {
    super(obj);
  }

  setOtherProperty(idGroup, sets, layoutGroup, layoutItem, rules) {
    super.setOtherProperty(idGroup, sets, layoutGroup, layoutItem, rules);

    this._removeClicked = this._stage.defConfig.hangman.removeClicked;
    if (typeof this.otherProperty.hangman === 'object' && this.otherProperty.hangman !== null && doll === false) {
      if (typeof this.otherProperty.hangman.removeClicked === 'boolean')
        this._removeClicked = this.otherProperty.hangman.removeClicked;
      doll = new dollHG(this.otherProperty.hangman, this._stage);
    }
  }

  stageMouseClick(e, data) {
    console.log('cjsHangman: CLICK');
    let engine = data.engine,
      stage = data.cjsStage;
    if (doll.isDead()) {
      e.stopPropagation();
      return;
    }
    engine.visible = !engine.removeClicked;
    if (engine.correct.length === 0) {
      doll.hangIt(stage);
      e.stopPropagation();
      return;
    }

    for (let i = 0; i < engine.correct.length; i++) {
      stage.groups[engine.correct[i].idGroup].items[engine.correct[i].idItem].check.visible = false;
    }

    e.stopPropagation();
  }

  set visible(v) {
    this.container.visible = v;
  }
  get removeClicked() {
    return this._removeClicked;
  }
}

cjsHangman.afterLoadSamples = function (stage) {
  if (doll._chances === -1 || doll._chances > Object.keys(stage.groups[doll.idGroup].items).length)
    doll._chances = Object.keys(stage.groups[doll.idGroup].items).length;

  let int = Math.floor(Object.keys(stage.groups[doll.idGroup].items).length / doll._chances);
  let mod = Object.keys(stage.groups[doll.idGroup].items).length % doll._chances;

  let c = 0,
    c2 = 0;
  for (let i = 0; i < Object.keys(stage.groups[doll.idGroup].items).sort().length; i++) {
    if (!Array.isArray(doll._imgs[c])) doll._imgs[c] = [];
    doll._imgs[c][c2] = Object.keys(stage.groups[doll.idGroup].items).sort()[i];
    stage.groups[doll.idGroup].items[doll._imgs[c][c2]].visible = false;
    c2++;
    if (c2 === int) {
      if (i / int === doll._chances - mod) int++;
      c2 = 0;
      c++;
    }
  }
};

cjsHangman.resetGameAction = function (stage) {
  console.log('cjsHangman RESET');
  cjsHangman.afterLoadSamples(stage);
};

class dollHG {
  _idGroup;
  _shot = 0;
  _chances;
  _imgs = [];

  constructor(obj, stage) {
    this._idGroup = obj.idGroup;
    this._chances = fJS.isNumeric(obj.chances) ? obj.chances : stage.defConfig.hangman.chances;
  }

  get idGroup() {
    return this._idGroup;
  }
  get chances() {
    return this._chances;
  }

  hangIt(stage) {
    for (let i = 0; i < this._imgs[this._shot].length; i++)
      stage.groups[this.idGroup].items[this._imgs[this._shot][i]].visible = true;
    this._shot++;
  }

  isDead() {
    return this._imgs[this._shot] === undefined;
  }
}
